if (!customElements.get("product-modal")) {
    class ProductModal extends ModalDialog {
        constructor() {
            super();

            this.bodyOverflowAttribute = "data-modal-opened";
            this.modalInner = this.querySelector(".product-media-modal--inner");
            this.media = [
                ...this.querySelectorAll(".product-media-modal--inner > *"),
            ];
            this.mediaThumbs = [
                ...this.querySelectorAll(".product-media-modal__thumbs > a"),
            ];
            this.loader = null;
            this.handleKeydown = this.handleKeydown.bind(this);
            this.showThumbMedia = this.showThumbMedia.bind(this);

            window.addEventListener("popstate", () => {
                this.hasAttribute("open") && this.hide();
            });
        }

        connectedCallback() {
            this.mediaThumbs.forEach((thumb) =>
                thumb.addEventListener("click", this.showThumbMedia)
            );
            document.addEventListener("keydown", this.handleKeydown);
        }

        hide() {
            super.hide();
            document.body.removeAttribute(this.bodyOverflowAttribute);
            window?.pauseAllMedia?.();
        }

        show(opener) {
            if (!this.querySelector(".loading-overlay")) this.initLoading();
            window.location.hash = "product-modal";
            super.show(opener);
            document.body.setAttribute(this.bodyOverflowAttribute, true);
            setTimeout(() => {
                this.showActiveMedia();
            }, 150);
        }

        showActiveMedia() {
            const activeMediaId = this.openedBy.dataset.mediaId;
            const activeMedia = this.media.find(
                (m) => m.dataset.mediaId === activeMediaId
            );

            if (!activeMedia) return;

            this.media.forEach((m) =>
                m.classList.toggle("active", m === activeMedia)
            );
            this.mediaThumbs.forEach((thumb) =>
                thumb.classList.toggle(
                    "active",
                    thumb.dataset.mediaId === activeMediaId
                )
            );

            activeMedia.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
            });

            if (activeMedia.nodeName === "IMG") {
                if (activeMedia.complete) this.hideLoading();
                else this.showLoading();
            }

            if (
                activeMedia.nodeName === "DEFERRED-MEDIA" &&
                activeMedia
                    .querySelector("template")
                    ?.content?.querySelector(".js-youtube")
            ) {
                activeMedia.loadContent();
            }
        }

        showThumbMedia(e) {
            e.preventDefault();

            if (!this.querySelector(".loading-overlay")) this.initLoading();

            const target = e.currentTarget.closest("a");
            if (!target) return;

            const currentMediaId = target.dataset.mediaId;
            this.activateMedia(currentMediaId);
        }

        activateMedia(currentMediaId) {
            window?.pauseAllMedia?.();

            this.mediaThumbs.forEach((thumb) =>
                thumb.classList.remove("active")
            );
            this.mediaThumbs
                .find((thumb) => thumb.dataset.mediaId === currentMediaId)
                ?.classList.add("active");

            this.media.forEach((media) => {
                const isActive = media.dataset.mediaId === currentMediaId;
                media.classList.toggle("active", isActive);
                media.removeAttribute("hidden");
                if (isActive) {
                    if (media.nodeName === "IMG" && !media.complete)
                        this.showLoading();
                }
            });
        }

        handleKeydown(event) {
            if (!this.hasAttribute("open") || !["ArrowLeft", "ArrowRight"].includes(event.key)) return;
            if (this.media.length < 2) return;

            event.preventDefault();
            const activeIndex = this.media.findIndex((media) => media.classList.contains("active"));
            const direction = event.key === "ArrowRight" ? 1 : -1;
            const nextIndex = (Math.max(activeIndex, 0) + direction + this.media.length) % this.media.length;
            const mediaId = this.media[nextIndex]?.dataset.mediaId;

            if (mediaId) {
                this.activateMedia(mediaId);
                this.mediaThumbs.find((thumb) => thumb.dataset.mediaId === mediaId)?.focus();
            }
        }

        async initLoading() {
            if (!this.loader) {
                const html = await fetchLoaderHTML();
                this.insertAdjacentHTML("afterbegin", html);
                this.loader = this.querySelector(".loading-overlay");
            }
        }

        showLoading() {
            this.loader?.classList.remove("hidden");
        }

        hideLoading() {
            this.loader?.classList.add("hidden");
        }

        disconnectedCallback() {
            this.mediaThumbs.forEach((thumb) =>
                thumb.removeEventListener("click", this.showThumbMedia)
            );
            document.removeEventListener("keydown", this.handleKeydown);
        }
    }

    customElements.define("product-modal", ProductModal);
}
